import { motion, useReducedMotion } from 'framer-motion';
import { BRAND_MARK_DEFAULTS } from '@/shared/components/brand-mark';
import { useBrand } from '@/shared/lib/brand';
import { cn } from '@/shared/lib/cn';

const { iconSize: ICON_SIZE, wordmarkSize: WORDMARK_SIZE, gap: BRAND_GAP } = BRAND_MARK_DEFAULTS;

const spring = { type: 'spring' as const, stiffness: 420, damping: 38, mass: 0.75 };

/**
 * Marca da sidebar — ícone fixo (sem layoutId/layout) + logotipo com morph
 * só na largura ao expandir/recolher. Evita o “salto” do logo em navegação.
 */
export function SidebarBrand({ collapsed, stable = false }: { collapsed: boolean; stable?: boolean }) {
  const { brand } = useBrand();
  const reduceMotion = useReducedMotion();
  const t = reduceMotion || stable ? { duration: 0 } : spring;
  const displayWordmarkSize = Math.round(WORDMARK_SIZE * brand.logotypeScale);
  const wordmarkWidth = Math.round(displayWordmarkSize * brand.logotypeAspect);

  return (
    <div className={cn('flex min-w-0 items-center', collapsed && 'w-full justify-center')}>
      <div className="shrink-0">
        <img
          src={brand.assets.icon.brand}
          alt=""
          width={ICON_SIZE}
          height={ICON_SIZE}
          decoding="async"
          className="object-contain"
          style={{ width: ICON_SIZE, height: ICON_SIZE }}
        />
      </div>

      <motion.div
        className="overflow-hidden"
        initial={false}
        animate={{
          width: collapsed ? 0 : wordmarkWidth,
          opacity: collapsed ? 0 : 1,
          marginLeft: collapsed ? 0 : BRAND_GAP,
        }}
        transition={t}
        aria-hidden={collapsed}
      >
        <motion.div
          className="relative"
          style={{ width: wordmarkWidth, height: displayWordmarkSize }}
          initial={false}
          animate={{
            x: collapsed ? -10 : 0,
            scale: collapsed ? 0.9 : 1,
          }}
          transition={t}
        >
          <img
            src={brand.assets.logotype.light}
            alt=""
            width={wordmarkWidth}
            height={displayWordmarkSize}
            decoding="async"
            className="absolute inset-0 h-full w-full object-contain object-left dark:hidden"
            style={{ filter: brand.assets.logotype.lightFilter }}
          />
          <img
            src={brand.assets.logotype.dark}
            alt=""
            width={wordmarkWidth}
            height={displayWordmarkSize}
            decoding="async"
            className="absolute inset-0 hidden h-full w-full object-contain object-left dark:block"
          />
        </motion.div>
      </motion.div>
    </div>
  );
}
